module.exports = __webpack_public_path__ + "img/symbol_7.efb4bee6.png";